import { Link, useLocation } from 'react-router-dom';
import { Card } from '../components/Card';
import { PageHeader } from '../components/PageHeader';
import { supportHomePath } from '../lib/supportNav';

export function NotFoundPage() {
  const location = useLocation();
  return (
    <main className="page-shell">
      <PageHeader title="Поддержка" />
      <div className="page-shell__body">
        <Card title="Страница не найдена">
          <p className="text-[14px] text-ink-muted mb-3">Похоже, ссылка устарела.</p>
          <Link to={supportHomePath(location)} className="text-ink underline text-[14px]">
            На главную
          </Link>
        </Card>
      </div>
    </main>
  );
}
